module.exports = __webpack_public_path__ + "img/11.8ea61cb2.jpg";